import { InstructorGroupInfo, InstructorGroupInfoType } from '@interfaces/LessonGroups'
import { DATE_FORMAT } from '@utils/constants'
import orderBy from 'lodash/orderBy'
import uniqBy from 'lodash/uniqBy'

type userDateFn = (date: string, format?: string, displayFormat?: string) => string

class MyBerlitzLessonGroup {
  lessonGroup?: InstructorGroupInfoType
  toUserDate?: userDateFn

  constructor(lessonGroup?: InstructorGroupInfo[], toUserDate?: userDateFn) {
    this.lessonGroup = lessonGroup?.[0]?.InstructorGroupInfo
    this.toUserDate = toUserDate
  }

  getPendingLessons = () => {
    if (typeof this.toUserDate !== 'function') {
      return []
    }
    return orderBy(
      this.lessonGroup?.GroupClassList?.map(GroupClassItem => {
        const StartTime = this.toUserDate && this.toUserDate(GroupClassItem.StartTime, DATE_FORMAT.DT, DATE_FORMAT.DT)
        const EndTime = this.toUserDate && this.toUserDate(GroupClassItem.EndTime, DATE_FORMAT.DT, DATE_FORMAT.DT)

        return {
          ...GroupClassItem,
          StartTime,
          EndTime,
          SessionInfoList: GroupClassItem.SessionInfoList.map(item => ({
            ...item,
            StartTime,
            EndTime,
          })),
        }
      }),
      ['StartTime']
    ).filter(
      ({ Status, SessionInfoList }) =>
        SessionInfoList.some(lesson => lesson.Status === 'Pending') || Status === 'Pending'
    )
  }

  get pendingLessons() {
    return this.getPendingLessons()
  }

  get pendingSessionCount() {
    return uniqBy(this.pendingLessons, 'SessionId').length
  }

  getGroupedPendingLessons = ({ ProgramId, LearningCenter }) =>
    this.pendingLessons?.filter(
      ClassList => ClassList.ProgramId === ProgramId && ClassList.LearningCenter === LearningCenter
    )
}

export default MyBerlitzLessonGroup
